<template>
  <div class="list d-f1">
    <div class="order">
      <div class="order-total">
        共找到 <b v-color:red class="px-1">{{ data.count }}</b> 个小区
      </div>
      <div class="order-body">
        <span @click="order(1, !sortType)" :class="{ ac: data.orderType === 1 }">
          <span>默认排序</span>
          <span></span>
        </span>
        <span @click="order(2, !sortType)" :class="{ ac: data.orderType === 2 }">
          <span>均价</span>
          <span class="pl-1">{{ !sortType ? '↑' : '↓' }}</span>
        </span>
      </div>
    </div>
    <hr class="mb-4" />
    <building-card v-for="a in list" :key="a.id" :obj="a" />
    <a-pager @update:page="pager" v-bind="data"></a-pager>
  </div>
</template>

<script>
export default {
  name: 'building-body',
  props: { list: Array, data: Object },
  data() {
    return { sortType: false };
  },
  methods: {
    order(orderType, sortType) {
      this.sortType = sortType;
      const obj = { ...this.data };
      obj.orderType = orderType;
      obj.sortType = sortType ? 2 : 1;
      this.$emit('update:data', obj);
      this.$emit('search');
    },
    pager(e) {
      this.$emit('update:data', { ...this.data, page: e });
      this.$emit('search');
    },
  },
};
</script>
<style lang="scss" scoped>
.order {
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  font-size: 2rem;
  background-color: white;

  &-body {
    > span {
      margin: 1rem 2rem;
      padding: 1rem 0;

      span:last-of-type {
        opacity: 0;
      }

      &.ac {
        color: var(--color);
        border-bottom: 2px solid;

        span:last-of-type {
          opacity: 1;
        }
      }
    }
  }
}
</style>
